import React, { useState } from "react";
import { BOOKING_TYPE } from "./Constants";
import Popover from "react-popover";
import info_icon from "../../assets/dashboard/info_icon.svg";

function CashPayment({
  consultationFees,
  hasAppliedDiscount,
  totalDiscount,
  totalFees,
  procedureFeeList,
  totalCustomGst,
  hasResourceAccess,
  addBooking,
  selectedBookingType,
}) {
  const [isOpen, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const handlePopoverOpen = (event) => {
    setOpen(true);
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setOpen(false);
    setAnchorEl(null);
  };

  // Display UI ===>
  function resourceAmounts() {
    let hasGst = procedureFeeList.some(
      (procedure) => +procedure?.custom_gst_in_rupees > 0
    );

    return (
      <div className="resource-ammount-table-container">
        <div className="resource-table-header">
          <div className="resorce-discription">Description of Service</div>
          <div className="resource-fee">Fee</div>
          {hasGst && <div className="resource-fee">GST</div>}
          <div className="resource-amount">Amount</div>
        </div>
        <div className="resource-body-content">
          {procedureFeeList?.map((data) => (
            <div className="resource-body-content-wrapper">
              <div className="resorce-discription">
                <div>{data.procedure_name}</div>
              </div>
              <div className="resource-fee">
                <div>₹{data.consultation_fees}</div>
              </div>
              {hasGst && (
                <div className="resource-gst">
                  <div>₹{data.custom_gst_in_rupees}</div>
                </div>
              )}
              <div className="resource-amount">
                <div>₹{data.amount_with_gst}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  const displayConsultationFeeSection = () => {
    let infoText = "GST is applied on discounted Consultation fee";
    return (
      <div className="online-payment-section-container">
        <div className="online-payment-section">
          <div>Consultation Fee</div>
          <div>
            {"₹ "} {consultationFees}
          </div>
        </div>
        {+totalDiscount > 0 && (
          <div className="online-payment-discount-section">
            <div>Total Discount</div>
            <div>
              {"₹ "} {totalDiscount}
            </div>
          </div>
        )}
        {+totalCustomGst > 0 && (
          <div className="online-payment-section" style={{ marginTop: "15px" }}>
            <div className="online-payment-gst-text">
              GST {displayInfo(infoText)}
            </div>
            <div>
              {"₹ "} {totalCustomGst}
            </div>
          </div>
        )}
      </div>
    );
  };

  const displayTotalFee = () => {
    return (
      <div className="online-payment-section-container">
        <div className="online-payment-total-fee-section">
          <div>TOTAL FEE</div>
          <div>
            {"₹ "} {totalFees}
          </div>
        </div>
      </div>
    );
  };

  const resourceDiscount = () => {
    return (
      <>
        {+totalDiscount > 0 && (
          <div className="online-payment-section-container">
            <div className="online-payment-discount-section m-0">
              <div>Total Discount</div>
              <div>
                {"₹ "} {totalDiscount}
              </div>
            </div>
          </div>
        )}
      </>
    );
  };

  const displayInfo = (info) => {
    return (
      <Popover
        isOpen={isOpen}
        preferPlace={`below`}
        place={null}
        anchorEl={anchorEl}
        body={displayHoverContent(info)}
      >
        <img
          src={info_icon}
          alt=""
          style={{ cursor: "pointer", marginLeft: "5px" }}
          onMouseOver={handlePopoverOpen}
          onMouseOut={handlePopoverClose}
        />
      </Popover>
    );
  };

  const displayHoverContent = (infoText) => {
    return (
      <div
        style={{
          padding: "6px 10px",
          fontSize: "12px",
          width: "100%",
          textAlign: "center",
        }}
      >
        {infoText}
      </div>
    );
  };

  // <===

  return (
    <div className="online-payment-container">
      {(hasResourceAccess ||
        (addBooking && selectedBookingType === BOOKING_TYPE.LABORATORY)) &&
        resourceAmounts()}
      {(hasResourceAccess ||
        (addBooking && selectedBookingType === BOOKING_TYPE.LABORATORY)) &&
        resourceDiscount()}
      {((!hasResourceAccess && !addBooking) ||
        (addBooking && selectedBookingType === BOOKING_TYPE.CLINIC)) &&
        displayConsultationFeeSection()}
      {displayTotalFee()}
    </div>
  );
}

export default CashPayment;
